import { useLocale, useTranslations } from 'next-intl'

import { TRoomDetail, useParkingTypeMap } from '@/entities/room'
import { cn } from '@/shared/lib'
import { ContentBox } from '@/shared/ui'

import { Heading, Item, Label, List, Value } from '../../common'

export type Props = Pick<
  TRoomDetail,
  'hasElevator' | 'parkingType' | 'parkingNotice'
>

export const Facilities = ({
  hasElevator,
  parkingType,
  parkingNotice,
}: Props) => {
  const locale = useLocale()
  const t = useTranslations('room_detail')
  const { PARKING_TYPE_MAP } = useParkingTypeMap()

  return (
    <section className="space-y-10">
      <div
        className={cn('w-[260px] space-y-5', locale === 'en' && 'w-[300px]')}
      >
        <Heading>{t('elevator_parking.title')}</Heading>
        <List spacing="medium" className="typo-body2 text-gray-900">
          <Item className="justify-between">
            <Label icon="elevator" className="font-semibold">
              {t('elevator_parking.elevator')}
            </Label>
            <Value>
              {hasElevator
                ? t('elevator.type.available')
                : t('elevator.type.not_available')}
            </Value>
          </Item>
          <Item className="justify-between">
            <Label icon="parking" className="font-semibold">
              {t('elevator_parking.parking')}
            </Label>
            <Value>{PARKING_TYPE_MAP[parkingType]}</Value>
          </Item>
        </List>
      </div>

      {parkingNotice && (
        <ContentBox spacing="medium" color="light-gray" className="space-y-2">
          <h4 className="typo-label1 font-semibold text-gray-900">
            {t('parking.info.title')}
          </h4>
          <div className="typo-label2 font-normal whitespace-break-spaces text-gray-500">
            {parkingNotice}
          </div>
        </ContentBox>
      )}
    </section>
  )
}
